define('pages/ads/ads_page_view',[
  'backbone',
  'jquery',
  '_',
  'modules/ads/ads_view',
  'modules/ads/ads_filter_view',
  'text!./ads_page_template.html',
], function (Backbone, $, _, AdsView, AdsFilterView, AdsPageTemplate) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);
      this.zone_id = this.params && this.params.zone_id;
      this.with_zone = !!this.zone_id;

      this.ads = new AdsView({
        with_zone: this.with_zone,
        zone_id: this.zone_id,
      });
      this.subViews.push(this.ads);

      this.filterView = new AdsFilterView();
      this.subViews.push(this.filterView);

      this.render();
      this.renderSubView();

      this.listenTo(this.filterView.filterModel, 'change', function (model) {
        this.ads.collection.params = _.extend(this.ads.collection.params, {
          period: model.get('adsPeriod'),
          search: model.get('searchText'),
          zone: model.get('zoneOptions').active[0],
          player_id: model.get('playerOptions').active[0],
          booking_type: model.get('bookingTypeOptions').active[0],
        });

        this.ads.collection.fetch();
      });
    },

    with_zone: false,
    template: _.template(AdsPageTemplate),
    subViews: [],
    showInfoText: false,
    events: {
      'click .js-button-back': 'backToPlayer',
      'click .js-switch-my-ads-period': 'switchMyAdsPeriod',
      'click .js-toggle-infotext': 'toggleInfoText',
    },

    render: function () {
      this.$el.html(this.template({ with_zone: this.with_zone }));
      return this;
    },

    renderSubView: function () {
      this.$('.ads-page-content').html(this.ads.$el);
      this.$('.ads-filters-content').html(this.filterView.$el);
    },

    backToPlayer: function (e) {
      e.preventDefault();
      Backbone.trigger('goBack', '/overview');
    },

    switchMyAdsPeriod: function (e) {
      var chosenPeriod = e.currentTarget.dataset.myAdsPeriod;

      $('.js-switch-my-ads-period.active').removeClass('active');
      $(
        '.js-switch-my-ads-period[data-my-ads-period="' + chosenPeriod + '"]'
      ).addClass('active');

      this.ads.collection.params = _.extend(this.ads.collection.params, {
        period: chosenPeriod,
        offset: 0
      });

      this.ads.collection.fetch();

      this.$('.ads-page-information-box').html(
        _.t('my_ads.information_text.' + chosenPeriod)
      );

      if (this.filterView.filterModel) {
        this.filterView.filterModel.set('adsPeriod', chosenPeriod);
      }
    },

    toggleInfoText: function () {
      this.showInfoText = !this.showInfoText;

      if (this.showInfoText) {
        this.$('.icon.icon-chevron-up').removeClass('hide');
        this.$('.icon.icon-chevron-down').addClass('hide');
        this.$('.panel-info-text').removeClass('hide');
        this.$('.page-actions').removeClass('is-top');
      } else {
        this.$('.icon.icon-chevron-up').addClass('hide');
        this.$('.icon.icon-chevron-down').removeClass('hide');
        this.$('.panel-info-text').addClass('hide');
        this.$('.page-actions').addClass('is-top');
      }
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});

